// extracted by mini-css-extract-plugin
export default {"group":"AceptacionCondiciones_group__AmDdq","checkbox":"AceptacionCondiciones_checkbox__eqd1x"};